import React, { memo } from 'react';
import PropTypes from 'prop-types';

const RadiologyTableMobile = ({ radiology }) => {
  return (
    <div className="cases-table-mobile">
      {radiology.map((r) => {
        return (
          <div key={r.id} className="case-mobile-row">
            <div className="d-flex space-between m-t-sm">
              <div className="m-r-md flex-1">{r.name}</div>
            </div>
            <div className="d-flex space-between m-t-sm">
              <div className="secondary">
                {r.description}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

RadiologyTableMobile.propTypes = {
  radiology: PropTypes.array,
};

export default memo(RadiologyTableMobile);
